
(function() {
    function initShippingCalculator() {
        const calculateButton = document.getElementById('ec-cart-shipping-calculate');
        if (!calculateButton) return;
        if (calculateButton.__ecShippingInitialized) return;
        calculateButton.__ecShippingInitialized = true;

        calculateButton.addEventListener('click', async function() {
            const zipCodeInput = document.getElementById('ec-cep-input');
            const shippingResult = document.getElementById('ec-cart-shipping-result');
            const loadingImg = calculateButton.querySelector('.ec-shipping-loading');
            const buttonSpan = calculateButton.querySelector('span');

            if (!zipCodeInput || !shippingResult) return;

            var zipCode = zipCodeInput.value;

            zipCode = zipCode.replace(/\D/g, '');
            if (zipCode.length === 8) {
                zipCode = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
                zipCodeInput.value = zipCode;
            } else {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                zipCodeInput.classList.add('error');
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
                return;
            }

            calculateButton.disabled = true;
            if (loadingImg) loadingImg.style.display = 'inline-block';
            if (buttonSpan) buttonSpan.style.display = 'none';
            shippingResult.innerHTML = '';

            var province = '';
            try {
                let response = await fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`);
                let data = await response.json();

                if (data.uf) {
                    province = data.uf;
                } else {
                    throw new Error("Não foi possível determinar o estado para o CEP fornecido.");
                }
            } catch (error) {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                zipCodeInput.classList.add('error');
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
                console.error('Erro:', error);
                return;
            }

            try {
                let response = await fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=BR&shipping_address[province]=${province}`);
                const data = await response.json();

                if (data.shipping_rates && data.shipping_rates.length > 0) {
                    let optionsHTML = '';
                    data.shipping_rates.forEach(function(rate) {
                        const price = rate.price.replace('.', ',');
                        const priceCents = rate.price;
                        const delivery = rate.delivery_time || 'Consultar';
                        const deliveryLabel = delivery === 'Consultar' ? delivery : 'Chega em até ' + delivery;
                        optionsHTML += `
                            <div class="ec-shipping-select-option" data-price="${priceCents}" data-name="${rate.name}" data-delivery="${delivery}" role="option">
                                <span class="ec-shipping-radio"></span>
                                <div class="ec-shipping-option-content">
                                    <span class="ec-shipping-option-name">${rate.name}</span>
                                    <span class="ec-shipping-option-delivery">${deliveryLabel}</span>
                                </div>
                                <span class="ec-shipping-option-price">R$ ${price}</span>
                            </div>
                        `;
                    });
                    shippingResult.innerHTML = `<div class="ec-shipping-options-list" role="listbox">${optionsHTML}</div>`;

                    const selectOptions = shippingResult.querySelectorAll('.ec-shipping-select-option');

                    function applySelection(optionEl) {
                        selectOptions.forEach(opt => opt.classList.remove('selected'));
                        optionEl.classList.add('selected');
                        const price = parseFloat(optionEl.getAttribute('data-price'));
                        const name = optionEl.getAttribute('data-name');
                        const delivery = optionEl.getAttribute('data-delivery');
                        window.selectedShippingPrice = price;
                        window.selectedShippingName = name;
                        window.selectedShippingDelivery = delivery;

                        const inputGroup = document.getElementById('ec-cep-input-group');
                        const freteSelected = document.getElementById('ec-cart-frete-selected');
                        const shippingResultDiv = document.getElementById('ec-cart-shipping-result');
                        if (inputGroup && freteSelected) {
                            inputGroup.style.display = 'none';
                            freteSelected.style.display = 'flex';
                            const cepElement = document.getElementById('ec-cart-frete-cep');
                            const priceElement = document.getElementById('ec-cart-frete-price');
                            if (cepElement) cepElement.textContent = 'CEP ' + zipCodeInput.value;
                            if (priceElement) priceElement.textContent = formatMoney(price);
                            if (shippingResultDiv) shippingResultDiv.style.display = 'none';
                        }
                        updateShippingSummary(price);
                        updateCartTotal();
                    }

                    selectOptions.forEach(option => {
                        option.addEventListener('click', function() {
                            applySelection(this);
                        });
                    });
                } else {
                    shippingResult.innerHTML = '<div class="ec-shipping-error">Nenhuma opção de frete disponível para este CEP.</div>';
                }
            } catch (error) {
                shippingResult.innerHTML = '<div class="ec-shipping-error">Erro ao obter opções de frete.</div>';
                console.error('Erro:', error);
            } finally {
                calculateButton.disabled = false;
                if (loadingImg) loadingImg.style.display = 'none';
                if (buttonSpan) buttonSpan.style.display = 'inline';
            }
        });

        const zipCodeInput = document.getElementById('ec-cep-input');
        if (zipCodeInput) {
            zipCodeInput.addEventListener('input', function(e) {
                this.classList.remove('error');
                const shippingResult = document.getElementById('ec-cart-shipping-result');
                if (shippingResult) {
                    shippingResult.innerHTML = '';
                }
            });

            zipCodeInput.addEventListener('blur', function(e) {
                const zipCode = this.value.replace(/\D/g, '');
                if (zipCode.length > 0 && zipCode.length !== 8) {
                    this.classList.add('error');
                    const shippingResult = document.getElementById('ec-cart-shipping-result');
                    if (shippingResult) {
                        shippingResult.innerHTML = '<div class="ec-shipping-error">Erro no CEP. Confira o número e tente novamente.</div>';
                    }
                }
            });
        }

        const changeCepButton = document.getElementById('ec-cart-change-cep');
        if (changeCepButton) {
            changeCepButton.addEventListener('click', function() {
                const inputGroup = document.getElementById('ec-cep-input-group');
                const freteSelected = document.getElementById('ec-cart-frete-selected');
                const shippingResult = document.getElementById('ec-cart-shipping-result');

                if (inputGroup && freteSelected) {
                    inputGroup.style.display = 'flex';
                    freteSelected.style.display = 'none';

                    window.selectedShippingPrice = null;
                    window.selectedShippingName = null;
                    window.selectedShippingDelivery = null;

                    if (shippingResult) {
                        shippingResult.innerHTML = '';
                        shippingResult.style.display = 'block';
                    }

                    const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
                    if (shippingLine) {
                        shippingLine.style.display = 'none';
                    }

                    updateCartTotal();
                }
            });
        }
    }

    function updateShippingSummary(price) {
        const shippingLine = document.getElementById('ec-cart-footer-shipping-line');
        const shippingValue = document.getElementById('ec-cart-shipping-value');

        if (shippingLine && shippingValue) {
            shippingLine.style.display = 'flex';
            shippingValue.textContent = formatMoney(price);
        }
    }

    function updateCartTotal() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(cart => {
                const totalValue = document.getElementById('ec-cart-total-value');
                const shippingPrice = window.selectedShippingPrice || 0;
                const total = parseFloat(cart.total_price / 100) + parseFloat(shippingPrice);

                if (totalValue) {
                    totalValue.textContent = formatMoney(total);
                }
            })
            .catch(err => console.error('Erro ao atualizar total:', err));
    }

    function formatMoney(cents) {
        return 'R$ ' + (cents).toFixed(2).replace('.', ',');
    }

    if (!window.__EC_SHIPPING_CALC_OBSERVED) {
        window.__EC_SHIPPING_CALC_OBSERVED = true;
        const observer = new MutationObserver(() => {
            initShippingCalculator();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initShippingCalculator);
    } else {
        initShippingCalculator();
    }

})();
